import { CheckSquare, Square } from "lucide-react";

interface PasswordRequirementsProps {
  password: string;
}

interface RequirementItemProps {
  isValid: boolean;
  text: string;
}

function RequirementItem({ isValid, text }: RequirementItemProps) {
  return (
    <li className="flex items-center gap-2">
      {isValid ? (
        <CheckSquare className="h-4 w-4 text-green-500" />
      ) : (
        <Square className="h-4 w-4 text-white" />
      )}
      <span className="text-white">{text}</span>
    </li>
  );
}

export function PasswordRequirements({ password }: PasswordRequirementsProps) {
  const hasMinLength = password.length >= 8;
  const hasSymbol = /[^A-Za-z0-9]/.test(password);

  // Return nothing if all requirements are met
  // if (hasMinLength && hasSymbol) {
  //   return null;
  // }

  return (
    <div className="absolute top-0 left-full ml-3 w-72 bg-brand-neutral-900 p-4 rounded-sm border hidden lg:block">
      <h4 className="font-medium text-sm text-white mb-3">
        Password Requirements:
      </h4>
      <ul className="space-y-1 text-xs">
        <RequirementItem isValid={hasMinLength} text="At least 8 characters" />
        <RequirementItem
          isValid={hasSymbol}
          text="Contains at least one symbol"
        />
      </ul>
    </div>
  );
}
